import React from "react";
import { LayersIcon, ClipboardCheckIcon, CompassIcon, Table2Icon, CameraIcon, BoxIcon } from "lucide-react";
import { tools } from "../data/content";
import { SectionCTA } from "./SectionCTA";
const iconMap: Record<(typeof tools)[number]['icon'], BoxIcon> = {
  frameworks: LayersIcon,
  checklists: ClipboardCheckIcon,
  mapping: CompassIcon,
  matrices: Table2Icon,
  visual: CameraIcon
};
export function Tools() {
  return <section className="bg-cream px-4 py-16" aria-labelledby="tools-title" data-id="element-262" data-mp="204iak6qlogj7">
      <div className="mx-auto max-w-3xl" data-id="element-263" data-mp="24527pab6bk5c">
        <h2 id="tools-title" className="text-center font-serif text-[1.9rem] font-bold leading-tight text-ink sm:text-4xl" data-id="element-264" data-mp="2440uaz6oqlkg">
          And you’ll also receive <span className="italic text-gold-dark" data-id="element-265" data-mp="1vbywl8o03jdv">immediate access</span> to:
        </h2>

        <ul className="mt-10 divide-y divide-ink/10 border-y border-ink/10" data-id="element-266" data-mp="2j2csja9pi2dq">
          {tools.map(t => {
          const Icon = iconMap[t.icon];
          return <li key={t.title} className="flex gap-4 py-5" data-id="element-267" data-mp="2nu4aiwesqzs9">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-ink" data-id="element-268" data-mp="2p0w5uc8dyxz8">
                  <Icon className="h-6 w-6 text-gold" aria-hidden="true" data-id="element-269" data-mp="2l13slm81s3nj" />
                </span>
                <div data-id="element-270" data-mp="2yrqutod0obod">
                  <h3 className="font-serif text-xl font-bold text-ink" data-id="element-271" data-mp="2yt1v3e7971aq">{t.title}</h3>
                  <p className="mt-1 text-base leading-relaxed text-muted" data-id="element-272" data-mp="2tzyyex76jbqb">{t.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mt-12 rounded-3xl bg-ink px-6 py-10 text-center text-white" data-id="element-273" data-mp="38rhk9bmq00hl">
          <h3 className="font-serif text-[1.7rem] font-bold leading-tight sm:text-4xl" data-id="element-274" data-mp="33so75kbcibhy">
            Any rhinoplasty case you study…
            <span className="mt-1 block italic text-gold" data-id="element-275" data-mp="3cqqfym1bm8fs">you’ll have a system to help you organize it.</span>
          </h3>
          <p className="mt-6 text-lg leading-loose text-white/80" data-id="element-276" data-mp="1ndd5ef2m7o68">
            Analyze it. Define the objectives. Structure the plan. Prepare your review. Document what you learn.
          </p>
        </div>

        <SectionCTA label="I want the complete Blueprint" data-id="element-277" data-mp="3igs03aqskk9t" />
      </div>
    </section>;
}